import { Component, Injectable, input, output, ViewEncapsulation } from '@angular/core'
import { NgbTimeAdapter, NgbTimepickerModule, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap'
import { FormsModule } from '@angular/forms'

@Injectable()
export class NgbTimeStringAdapter extends NgbTimeAdapter<string> {
  fromModel(value: string | null): NgbTimeStruct | null {
    if (!value) {
      return null
    }
    const [h, m, s] = value.split(':')
    return {
      hour: parseInt(h ?? '0', 10),
      minute: parseInt(m ?? '0', 10),
      second: parseInt(s ?? '0', 10),
    }
  }

  toModel(time: NgbTimeStruct | null): string | null {
    return time != null
      ? `${(time.hour ?? 0).toString().padStart(2, '0')}:${(time.minute ?? 0)
        .toString()
        .padStart(2, '0')}:${(time.second ?? 0).toString().padStart(2, '0')}`
      : null
  }
}

@Component({
  selector: 'div[timeStringPicker]',
  imports: [NgbTimepickerModule, FormsModule],
  encapsulation: ViewEncapsulation.None,
  styles: `
    .app-time-picker > fieldset > .ngb-tp {
      & > .ngb-tp-input-container {
        width: unset;

        & > .ngb-tp-input.form-control {
          height: 1.5rem;
          min-height: 1.5rem;
          max-height: 1.5rem;
          width: 5rem;
          border: 1px solid black;
          border-radius: 0.25rem;
          outline: none;
          box-shadow: none;
          padding: 0 1.5rem;
          margin: 0;
          font-size: 0.9rem;
          line-height: 0.9rem;
        }
      }
    }

    .app-time-picker.with-seconds > fieldset > .ngb-tp {
      justify-content: space-between;
      & > .ngb-tp-input-container  .ngb-tp-input.form-control { 
        width: 5.5rem;
      }
    }
  `,
  template: `
    <ngb-timepicker
      class="app-time-picker"
      [class.with-seconds]="showSeconds()"
      [ngModel]="value()"
      (ngModelChange)="handleModelChange($event)"
      [disabled]="disabled()"
      [spinners]="false"
      [meridian]="false"
      [seconds]="showSeconds()"
    />
  `,
  providers: [{ provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter }],
})
export class TimeStringPickerComponent {
  readonly value = input<string | null>()
  readonly showSeconds = input(false)
  readonly disabled = input(false)

  readonly valueChange = output<string>()

  protected handleModelChange(newValue: string) {
    this.valueChange.emit(newValue)
  }
}
